
import { eventTopicName } from "helpers/mqtt/mqtt-helpers";
import { getUserId } from "helpers/cookies";

/*
  MQTT message format (raw JSON, no wrapper):
  {
      "event": "applicant",
      "crud": "CREATE",
      "tree_id": 15902,
      "node_id": 169028,
      "leaf_id": 19797,
      "callback": false,
      "receiver_id": 7610,
      "meta": { ... }
  }
*/

const subscribe = (mqttClient, loadSingleShiftDispatch, loadSingleApplicantDispatch, loadSingleFreePostDispatch, removeShiftFromReducer) => {
    if (!mqttClient) {
        console.warn('[ScheduleCalendarRealtimeHandler] MQTT client not available, skipping subscribe');
        return null;
    }

    const topicName = eventTopicName();

    const handleMessage = (topic, payload) => {
        let message;
        try {
            message = JSON.parse(payload.toString());
        } catch (err) {
            console.error('[ScheduleCalendarRealtimeHandler] Failed to parse MQTT message:', err);
            return;
        }
        console.log('[ScheduleCalendarRealtimeHandler] MQTT message:', message);

        if ( message.receiver_id == getUserId() ) {
            if ( message.event === 'open_shift' || message.event === 'shift' ) {
                if ( message.crud === 'NEW' || message.crud === 'UPDATE' ){
                    console.log('loadSingleShiftDispatch');
                    loadSingleShiftDispatch(message.leaf_id);
                }else if ( message.crud === 'DELETE' ){
                    removeShiftFromReducer(message.leaf_id);
                }
            }else if( message.event === 'applicant' ) {
                if ( message.crud === 'CREATE' || message.crud === 'UPDATE' ) {
                    loadSingleApplicantDispatch(message.leaf_id);
                    loadSingleShiftDispatch(message.meta.schedule_element_id);
                }
            }else if ( message.event === 'free_post' ) {
                if ( message.crud === 'NEW' ) {
                    console.log('loadSingleFreePostDispatch');
                    loadSingleFreePostDispatch(message.node_id);
                }
            }else if ( message.event === 'shift_inventory') {
                if ( message.crud === 'NEW' || message.crud === 'UPDATE') {
                    loadSingleShiftDispatch(message.leaf_id);
                }else if ( message.crud === 'DELETE') {
                    removeShiftFromReducer(message.leaf_id)
                }
            }
        }
    };

    mqttClient.on('message', handleMessage);
    mqttClient.subscribe(topicName);

    // Return handler reference for cleanup
    return { handler: handleMessage, topic: topicName };
}

export default {
    subscribe,
};